import { FormInitializerReturnType, numberSchema } from 'src/Configuration/validation'
import { SmartPowerSettingsFormModel, SmartPowerSettingsModel } from '../models'
import { modelToSettingsForm } from '../transformers'
import { SmartPowerValidationBoundaries } from '../types'
import { boolean, object } from 'yup'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { SmartPowerSettingsForm } from '../models/smart-power-settings-form.model'

const INITIAL_POWER_NUMBER = 0
const initialSmartPower: SmartPowerSettingsFormModel = {
  emsPowersaveEnabled: false,
  emsPowerLimitsUsed: false,
  emsMaxChargePower: INITIAL_POWER_NUMBER,
  emsMaxDischargePower: INITIAL_POWER_NUMBER,
  emsDischargeStartPower: INITIAL_POWER_NUMBER,
}

/**
 * Initializes the form for editing smart power settings
 * @param smartPowerSettings SmartPowerSettingsModel
 * @param validationBoundaries min, max boundaries
 * @returns initialValues and validationSchema for smart power settings form
 */
export const useSmartPowerFormInitializer = (
  smartPowerSettings: SmartPowerSettingsModel | null,
  validationBoundaries: SmartPowerValidationBoundaries
): FormInitializerReturnType<SmartPowerSettingsForm, SmartPowerSettingsFormModel> => {
  const { t } = useCustomTranslation()
  const numberSchemaWithTranslation = numberSchema(t)
  const { maxChargePower, maxDischargePower, maxStartDischargePower, minStartDischargePower, minChargePower, minDischargePower } =
    validationBoundaries

  const initialValues = smartPowerSettings ? modelToSettingsForm(smartPowerSettings) : initialSmartPower

  const validationSchema = object().shape({
    emsPowersaveEnabled: boolean().required(),
    emsPowerLimitsUsed: boolean().required(),
    emsMaxChargePower: numberSchemaWithTranslation({ min: minChargePower, max: maxChargePower }).when('emsPowerLimitsUsed', {
      is: true,
      then: schema => schema.required(),
    }),
    emsMaxDischargePower: numberSchemaWithTranslation({ min: minDischargePower, max: maxDischargePower }).when('emsPowerLimitsUsed', {
      is: true,
      then: schema => schema.required(),
    }),
    emsDischargeStartPower: numberSchemaWithTranslation({ min: minStartDischargePower, max: maxStartDischargePower }).when('emsPowerLimitsUsed', {
      is: true,
      then: schema => schema.required(),
    }),
  })

  return { initialValues, validationSchema }
}
